/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Funnel = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="M20.5399997,5.2299997 L19.1500004,3.54999974 C18.879998,3.20999984 18.4699982,2.99999982 17.9999998,2.99999982 L5.99999982,2.99999982 C5.5299994,2.99999982 5.11999957,3.20999984 4.83999986,3.54999974 L3.45999982,5.2299997 C3.16999988,5.56999984 2.99999982,6.01999962 2.99999982,6.49999982 L10.0062866,14.0088501 L10.0062866,19.7281494 L14.0054932,22.7265625 L14.0054932,14.0088501 L20.9999998,6.49999982 C20.9999987,6.01999962 20.8299987,5.56999936 20.5399997,5.2299997 Z M5.11999957,4.99999976 L5.92999946,3.99999976 L17.9299992,3.99999976 L18.8699997,4.99999976 L5.11999957,4.99999976 Z"
    />
  </Icon>
);
